<template>
    <div class="header-analytics-correctness">
        <h1 class="header-analytics-correctness__h1">Doğruluk Analitikleri</h1>
        <p class="header-analytics-correctness__desc-text">Ne kadar başarılı olduğunu incele.</p>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped src="@/css/components/header-analytics-correctness.css"></style>